import { useAccount } from '@corratech/pylot-auth-manager/src/use-account'
import { useCart, createCart } from '@corratech/pylot-cart-manager'
import { useRouter } from 'next/router'
import { getIsSignedIn } from '@corratech/pylot-auth-manager/src/utils/getIsSignedIn'

type UseLogoutReturn = { logout: () => Promise<void> }

export const useLogout = (): UseLogoutReturn => {
    const { locale } = useRouter()
    const { mutate: updateAccount } = useAccount()
    const { mutate: fetchNewCart } = useCart()

    return {
        logout: async () => {
            const isSignedIn = getIsSignedIn()
            if (isSignedIn) {
                window.localStorage.removeItem('pylot_token')
                window.localStorage.removeItem('public_hash')
                window.localStorage.removeItem('cart_id')
                // Delete customer data from SWR cache without triggering an unnecessary GQL query
                updateAccount({ data: { customer: undefined } }, false)
                await createCart({ locale })
                fetchNewCart()
            }
        }
    }
}
